<div class="mt-20" fxLayout="row" fxLayoutAlign="center">
    <div class="text-center" fxAlignAlign="center" fxFlex="50">
        <p>Thank you for your submission.  Your confirmation number is {{requestId}}.</p>
    </div>
</div>
<div fxLayout="row" fxLayoutAlign="center">
    <div class="text-center" fxAlignAlign="center" fxFlex="50">
        <button mat-raised-button color="primary" [routerLink]="['/']">Submit Another Request</button>
    </div>
</div>
